import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import userStore from "../../zustand/userStore";
import AllFeatureDataTable from "../../GuiComponents/AllFeatureDataTable.table";
import Popup from "../../features/EventOrganiser/Popup";
import { handlePopup, handleShowPopup } from "./redux/userSlice";
import { fetchOrgUsersById, fetchUserCrudAccess, unassignTeacherThunk } from "./redux/userThunk";
import CrudAccess from "./CrudAccess";
import UserSelector from "./UserSelector";
import AssignTeacher from "./AssignTeacher";
import TeacherDetails from "./TeacherDetails";
import UpdatePassword from "./UpdatePassword";
import { setAppdAiUser } from "../../utils/appdAiHelpers";

const UserList = () => {
  const userData = userStore((state) => state.user);
  const { users, loading, error, showForm, showPopup } = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();

  const [processedUsers, setProcessedUsers] = useState([]);
  const [showAssignTeacherPopup, setShowAssignTeacherPopup] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [showTeacherDetailsPopup, setShowTeacherDetailsPopup] = useState(false);
  const [selectedTeacherId, setSelectedTeacherId] = useState(null);
  const [showUpdatePasswordPopup, setShowUpdatePasswordPopup] = useState(false);

  const userId = userStore((state) => state.user.id);

  // const userNumberLimit = userData.payments?.at(0).no_of_users || 0;
  const userNumberLimit = userData?.payments?.[0]?.no_of_users ?? 0;

  // const planType = userData.payments?.at(0).plan_type || "";
  const planType = userData?.payments?.[0]?.plan_type ?? "";

  useEffect(() => {
    if (userId) {
      dispatch(fetchOrgUsersById(userId));
    }
  }, [userId, dispatch]);

  // useEffect(() => {
  //   if (userData) setAppdAiUser(userData, "demo");
  // }, []);


  const dataTableColumns = [
    {
      Header: "#",
      accessor: "sno",
    },
    {
      Header: "User Name",
      accessor: "name",
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "Role",
      accessor: "role_name",
    },
    {
      Header: "Actions",
      accessor: "actions",
    },
  ];

  const handleUserCrudClick = (userId) => {
    dispatch(handleShowPopup({ show: true, userId }));
    dispatch(fetchUserCrudAccess(userId));
  };

  const handleUpdatePasswordClick = (userId) => {
    setSelectedUserId(userId);
    setShowUpdatePasswordPopup(true);
  };



  const handleRemoveTeacherDirect = async (teacherId) => {
    if (!window.confirm("Are you sure you want to remove/unassign this teacher?")) {
      return;
    }
    try {
      await dispatch(unassignTeacherThunk(teacherId)).unwrap();
      alert("Teacher unassigned successfully!");
      dispatch(fetchOrgUsersById(userId));
    } catch (err) {
      alert(err || "Failed to unassign teacher");
    }
  };

  const processData = (usersArray) => {
    return usersArray.map((user, index) => ({
      ...user,
      sno: index + 1,
      name: (
        <span>
          {user.name}
          {Number(user.created_by) === 0 && (
            <span style={{ color: "#6c757d", fontStyle: "italic", marginLeft: "6px" }}>(You)</span>
          )}
        </span>
      ),
      actions: (
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <i
            className="fa fa-lock"
            style={{ cursor: "pointer", color: "#007BFF" }}
            title="CRUD Access"
            onClick={() => handleUserCrudClick(user.id)}
          ></i>
          {user.id !== userId && (
            <i
              className="fa fa-key"
              style={{ cursor: "pointer", color: "#FF9800" }}
              title="Update Password"
              onClick={() => handleUpdatePasswordClick(user.id)}
            ></i>
          )}
          {user.role_name?.toLowerCase() === "user" && (
            !user.teacher_id ? (
              <button
                className="btn btn-sm btn-outline-primary"
                style={{ fontSize: "12px", padding: "2px 6px" }}
                onClick={() => {
                  setSelectedUserId(user.id);
                  setShowAssignTeacherPopup(true);
                }}
              >
                Assign Teacher
              </button>
            ) : (
              <>
                <button
                  className="btn btn-sm btn-outline-info"
                  style={{ fontSize: "12px", padding: "2px 6px" }}
                  onClick={() => {
                    setSelectedTeacherId(user.teacher_id);
                    setShowTeacherDetailsPopup(true);
                  }}
                >
                  View Teacher Details
                </button>
                <button
                  className="btn btn-sm btn-outline-danger"
                  style={{ fontSize: "12px", padding: "2px 6px" }}
                  onClick={() => handleRemoveTeacherDirect(user.teacher_id)}
                >
                  Remove Teacher
                </button>
              </>
            )
          )}
        </div>
      ),
    }));
  };

  const handleAddUser = (e) => {
    e.preventDefault();

    const hideLoggedInUser = processedUsers.filter((u) => u.id !== userId);

    // If role is guest_user and plan_type is complete, allow adding users
    const isGuestUserComplete =
      userData?.roles === "guest_user" &&
      (planType === "complete" || planType?.toLowerCase() === "complete");

    const isRestrictedRole =
      !isGuestUserComplete &&
      ["guest_user", "teacher"].includes(userData?.roles);

    if (isRestrictedRole && hideLoggedInUser.length >= userNumberLimit - 1) {
      return alert("Your limit exceeded, please upgrade your plan.");
    }

    if (planType === "customized" && hideLoggedInUser.length >= userNumberLimit) {
      return alert(
        `You have reached the maximum number of users allowed in your plan.`
      );
    }

    dispatch(handlePopup(true));
  };

  // const processedUsers = processData(users || []);
  // issue: inline call creates a new array ref every render → `AllFeatureDataTable` (react-table v7 useTable) kept re-initializing → "Maximum update depth exceeded" infinite loop. Store processed data in state like Records.js so the reference is stable.
  useEffect(() => {
    setProcessedUsers(processData(users || []));
  }, [users]);

  if (planType === "customized" && userNumberLimit === 1)
    return (
      <h5>
        Your current subscription plan does not allow access to the user module.
      </h5>
    );

  return (
    <div className="container-fluid px-5 px-2">
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
          <button
            className="btn btn-primary btn-sm"
            style={{
              borderStyle: "none",
              borderRadius: "5px",
              color: "#fff",
              cursor: "pointer",
              padding: "4px 12px",
              fontSize: "13px"
            }}
            onClick={handleAddUser}
          >
            Add User
          </button>
        </div>

        {loading && <p>Loading...</p>}
        {error && <p className="text-danger">Error: {error}</p>}

        {processedUsers.length > 0 ? (
          <AllFeatureDataTable
            columns={dataTableColumns}
            data={processedUsers}
          />
        ) : (
          !loading && <p>No Users Found</p>
        )}
        {showForm && (
          <Popup
            title={"Create New User "}
            minHeight="auto"
            maxWidth="800px"
            onClose={() => dispatch(handlePopup(false))}
          >
            {/* <CreateUser /> */}
            <UserSelector />
          </Popup>
        )}
        {showPopup && (
          <Popup
            title={"CRUD Access "}
            minHeight="250px"
            maxWidth="1000px"
            onClose={() => dispatch(handleShowPopup(false))}
          >
            <CrudAccess />
          </Popup>
        )}
        {showAssignTeacherPopup && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1050,
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "15px",
                width: "90%",
                maxWidth: "600px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                  borderBottom: "1px solid #dee2e6",
                  paddingBottom: "10px",
                }}
              >
                <h6 style={{ margin: 0, fontWeight: "600" }}>Assign Teacher</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowAssignTeacherPopup(false);
                    setSelectedUserId(null);
                  }}
                  style={{ border: "none", background: "none", fontSize: "20px", cursor: "pointer" }}
                >
                  &times;
                </button>
              </div>
              <AssignTeacher
                userId={selectedUserId}
                onClose={() => {
                  setShowAssignTeacherPopup(false);
                  setSelectedUserId(null);
                }}
              />
            </div>
          </div>
        )}
        {showTeacherDetailsPopup && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1050,
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "15px",
                width: "90%",
                maxWidth: "600px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                  borderBottom: "1px solid #dee2e6",
                  paddingBottom: "10px",
                }}
              >
                <h6 style={{ margin: 0, fontWeight: "600" }}>Teacher Details</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowTeacherDetailsPopup(false);
                    setSelectedTeacherId(null);
                  }}
                  style={{ border: "none", background: "none", fontSize: "20px", cursor: "pointer" }}
                >
                  &times;
                </button>
              </div>
              <TeacherDetails
                teacherId={selectedTeacherId}
                onClose={() => {
                  setShowTeacherDetailsPopup(false);
                  setSelectedTeacherId(null);
                }}
              />
            </div>
          </div>
        )}

        {showUpdatePasswordPopup && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1050,
            }}
          >
            <div
              style={{
                backgroundColor: "#fff",
                padding: "20px",
                borderRadius: "15px",
                width: "90%",
                maxWidth: "400px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "15px",
                  borderBottom: "1px solid #dee2e6",
                  paddingBottom: "10px",
                }}
              >
                <h6 style={{ margin: 0, fontWeight: "600" }}>Update Password</h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowUpdatePasswordPopup(false)}
                  style={{ border: "none", background: "none", fontSize: "20px", cursor: "pointer" }}
                >
                  &times;
                </button>
              </div>
              <UpdatePassword
                userId={selectedUserId}
                onClose={() => setShowUpdatePasswordPopup(false)}
              />
            </div>
          </div>
        )}
    </div>
  );
};

export default UserList;
